var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect, _rect2, _path1, _path10, _circle, _circle2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0011 74.1873C23.0011 45.8502 46.0741 23 74.407 23C102.74 23 125.813 45.8333 125.813 74.1873C125.813 86.2159 121.644 97.2774 114.664 106.012C105.032 118.108 90.3289 125.376 74.4059 125.376C58.483 125.376 43.7604 118.063 34.1406 106.012C27.1604 97.2785 23 86.2169 23 74.1873H23.0011Z",
    fill: "url(#paint0_linear_19551_5107)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.34 77.0537C134.224 76.0286 134.093 74.4709 133.063 73.5906C132.034 72.7102 130.482 72.8275 129.598 73.8526C128.714 74.8777 128.82 76.4365 129.85 77.3179C130.879 78.1982 132.457 78.0788 133.341 77.0537H133.34Z",
    fill: "url(#paint1_linear_19551_5107)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.762 69.5801C134.325 68.927 134.241 67.9368 133.586 67.3756C132.93 66.8155 131.943 66.8905 131.381 67.5426C130.818 68.1957 130.885 69.187 131.541 69.7481C132.197 70.3082 133.201 70.2321 133.763 69.5801H133.762Z",
    fill: "url(#paint2_linear_19551_5107)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7623 26.5801C45.3248 25.927 45.241 24.9368 44.5861 24.3756C43.9303 23.8155 42.9432 23.8905 42.3807 24.5426C41.8182 25.1957 41.8851 26.187 42.541 26.7481C43.1969 27.3082 44.2009 27.2321 44.7634 26.5801H44.7623Z",
    fill: "url(#paint3_linear_19551_5107)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0008 122.205C40.3574 121.422 39.9976 120.494 39.2112 120.139C38.4247 119.784 37.4972 120.132 37.1406 120.916C36.784 121.699 37.1289 122.633 37.9153 122.988C38.7018 123.343 39.6442 122.989 40.0008 122.206V122.205Z",
    fill: "url(#paint4_linear_19551_5107)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7157 126.465C48.276 125.234 47.7104 123.777 46.4739 123.219C45.2375 122.661 43.7814 123.207 43.221 124.438C42.6606 125.669 43.2019 127.136 44.4383 127.693C45.6748 128.251 47.1553 127.695 47.7157 126.464V126.465Z",
    fill: "url(#paint5_linear_19551_5107)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3403 31.0537C41.2244 30.0286 41.0928 28.4709 40.0633 27.5906C39.0338 26.7102 37.4822 26.8275 36.5981 27.8526C35.714 28.8777 35.8201 30.4365 36.8496 31.3179C37.8791 32.1982 39.4573 32.0788 40.3413 31.0537H40.3403Z",
    fill: "url(#paint6_linear_19551_5107)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1119 30.0514L89.1124 30.0518L106.636 46.1302L106.636 46.1303C107.637 47.0479 108.325 48.2436 108.617 49.5423L108.618 49.5475C108.736 50.0314 108.791 50.523 108.791 51.0318V51.3318H108.792V114.045C108.792 117.724 105.817 120.699 102.139 120.699H44.9532C41.2751 120.699 38.3 117.724 38.3 114.045V34.9534C38.3 31.2752 41.2751 28.3 44.9532 28.3H84.6228C84.9693 28.3 85.3104 28.3275 85.6454 28.3763C86.9306 28.5777 88.1397 29.1553 89.1119 30.0514Z",
    fill: "white",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.524 49.1774H89.0562C87.3633 49.1774 85.9904 47.8045 85.9904 46.1116V28.4406C87.1464 28.685 88.2272 29.2368 89.112 30.0522L89.1125 30.0527L106.636 46.1311L106.636 46.1312C107.543 46.962 108.192 48.0207 108.524 49.1774Z",
    fill: "url(#paint7_linear_19551_5107)",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 111C45.5 109.895 46.3954 109 47.5 109H93.5C94.6046 109 95.5 109.895 95.5 111V113C95.5 114.105 94.6046 115 93.5 115H47.5C46.3954 115 45.5 114.105 45.5 113V111Z",
    fill: "#C3CEF5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 35,
    width: 33,
    height: 6,
    rx: 2,
    fill: "#C3CEF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 45,
    width: 18,
    height: 6,
    rx: 2,
    fill: "#C3CEF5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M112.875 102.965L107.964 107.855L102.281 102.204C104.172 100.783 105.873 99.0648 107.201 97.314L112.876 102.965H112.875Z",
    fill: "url(#paint8_linear_19551_5107)",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M116.556 102.135L127.548 113.08C130.151 115.672 130.151 119.877 127.548 122.469C124.944 125.061 120.722 125.061 118.118 122.469L107.127 111.524C106.343 110.744 106.343 109.478 107.127 108.697L113.717 102.135C114.501 101.355 115.773 101.355 116.556 102.135Z",
    fill: "url(#paint9_linear_19551_5107)",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 87.8213,
    cy: 81.8213,
    r: 25.5213,
    fill: "url(#paint10_linear_19551_5107)",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.168,
    cy: 82.168,
    r: 18.5914,
    fill: "url(#paint11_linear_19551_5107)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19551_5107",
    x1: 30.5,
    y1: 28.5,
    x2: 91,
    y2: 132.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEEF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19551_5107",
    x1: 131.464,
    y1: 73,
    x2: 131.464,
    y2: 77.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19551_5107",
    x1: 132.568,
    y1: 67,
    x2: 132.568,
    y2: 70.1233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19551_5107",
    x1: 43.568,
    y1: 24,
    x2: 43.568,
    y2: 27.1233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19551_5107",
    x1: 38.5694,
    y1: 120,
    x2: 38.5694,
    y2: 123.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_19551_5107",
    x1: 45.4662,
    y1: 123,
    x2: 45.4662,
    y2: 127.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_19551_5107",
    x1: 38.4638,
    y1: 27,
    x2: 38.4638,
    y2: 31.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_19551_5107",
    x1: 85.6904,
    y1: 38.779,
    x2: 108.91,
    y2: 38.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_19551_5107",
    x1: 102.281,
    y1: 102.585,
    x2: 112.875,
    y2: 102.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7DFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_19551_5107",
    x1: 112.094,
    y1: 104.544,
    x2: 127.586,
    y2: 121.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95A8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_19551_5107",
    x1: 69.23,
    y1: 62.1971,
    x2: 107.962,
    y2: 103.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6B9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE4FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_19551_5107",
    x1: 75.2574,
    y1: 68.2245,
    x2: 99.5294,
    y2: 97.1444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.1a090e02383f45fa1945981c77a90173.svg";
export { ForwardRef as ReactComponent };